<template>
  <div>
    <div class="flex items-center justify-center my-6">
      <svg
        class="button-module_button__icon--prefix__dBABA"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4 5.5C4 4.67157 4.67157 4 5.5 4H18.8155C19.954 4 20.6775 5.21872 20.1323 6.21828L18.2001 9.76057C18.1187 9.90981 18.1187 10.0902 18.2001 10.2394L20.1323 13.7817C20.6775 14.7813 19.954 16 18.8155 16H5V22H4V5.5ZM5 15H18.8155C19.195 15 19.4361 14.5938 19.2544 14.2606L17.3222 10.7183C17.078 10.2706 17.078 9.72944 17.3222 9.28172L19.2544 5.73943C19.4361 5.40624 19.195 5 18.8155 5H5.5C5.22386 5 5 5.22386 5 5.5V15Z"
          fill="currentColor"
        ></path>
      </svg>
      <button
        @click="openReportModal()"
        class="pl-1 text-sm font-light underline text-primary"
      >
        Report this listing
      </button>
    </div>

    <!-- <div class="flex items-center justify-center w-full">
      <div
        class="flex flex-col p-8 bg-white border border-gray-100 shadow-md w-[22rem] justify-center items-center"
      >
        <h1 class="font-semibold text-center text-gray-700">
          Own this property from just
        </h1>
        <div class="flex items-center mt-4">
          <p class="text-4xl font-extrabold text-gray-700">58,747</p>
          <p>AED/month</p>
        </div>
        <div class="flex items-center mt-4">
          <p class="text-gray-600">Fixed rates from</p>
          <p class="pl-1 font-medium">3.94%</p>
        </div>
        <button
          class="w-full p-2 mt-5 bg-transparent border rounded h-11 border-primary text-primary"
        >
          Get pre-approved
        </button>
        <p class="mt-5 text-sm text-gray-500">in partnership with</p>
      </div>
    </div> -->
  </div>
  <ReportModal
    :property_id="property.id"
    :user_id="user_id"
    :showViewModal="showReportModal"
    @closeViewModal="closeReportModal"
  />

  <SignInModal
    :showViewModal="showLoginModal"
    :modalType="modalType"
    @closeViewModal="closeModal"
    @switchModalType="handleSwitchModalType"
  />
</template>
<script>
import { ref, watch } from "vue";
import ReportModal from "../properties/components/ReportModal.vue";
import useAuth from "@/composables/useAuth";
import SignInModal from "@/components/LoginModal.vue";
export default {
  components: {
    ReportModal,
    SignInModal,
  },
  props: {
    property: Object,
  },
  setup() {
    const { state: authState } = useAuth();
    const isAuthenticated = ref(authState.isAuthenticated);
    const user_id = ref("");
    if (isAuthenticated.value) {
      user_id.value = authState.user.id;
    }
    watch(
      () => authState.isAuthenticated,
      (newVal) => {
        isAuthenticated.value = newVal;
      }
    );
    const isDropdownOpen = ref(false);
    const showLoginModal = ref(false);
    const modalType = ref("");

    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const showReportModal = ref(false);
    const openReportModal = () => {
      if (isAuthenticated.value == true) {
        showReportModal.value = true;
      } else {
        showLoginModal.value = true;
        modalType.value = "login";
      }
    };

    const closeReportModal = () => {
      showReportModal.value = false;
    };

    const closeModal = () => {
      showLoginModal.value = false;
      modalType.value = "";
    };

    const handleSwitchModalType = (type) => {
      modalType.value = type;
    };

    return {
      handleSwitchModalType,
      user_id,
      closeModal,
      showLoginModal,
      modalType,
      closeReportModal,
      openReportModal,
      showReportModal,
      isDropdownOpen,
      toggleDropdown,
    };
  },
};
</script>
